import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'JobNotificationSearchPipe', pure: false })
export class JobNotificationSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    let searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(jobnotification => {
        if (jobnotification.text) {
          return jobnotification.text.search(searchText) !== -1;
        }
      });
    }
  }
}